import { render, staticRenderFns } from "./ttshop_recharge.vue?vue&type=template&id=4561e136&scoped=true&"
import script from "./ttshop_recharge.vue?vue&type=script&lang=js&"
export * from "./ttshop_recharge.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_recharge.vue?vue&type=style&index=0&id=4561e136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4561e136",
  null
  
)

export default component.exports